import { NavBar } from "../../components";
import { PdfPmmGuardianFile } from "../../components/pdf/files/PdfPmmGuardianFile";
import { PmmGuardianForm } from "../../components/solution/simulators/pmmGuardian/PmmGuardianForm";
import { PDFView } from "../../components/pdf";
import styles from "../main.module.sass";
import CancelIcon from "@mui/icons-material/Cancel";
import PrintIcon from "@mui/icons-material/Print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState, useContext } from "react";
import SimulatorContext from "../../context/SimulatorContext";

export const PmmGuardianSimulator = () => {
  const [inPdf, setInPdf] = useState(false);
  const { pmmGuardianValues, pmmGuardianResults, handleCancelSimulation } =
    useContext(SimulatorContext);

  const buttons = [
    {
      title: "Cancel",
      action: handleCancelSimulation,
      icon: <CancelIcon />,
      disabled: false,
    },
    {
      title: inPdf ? "Return" : "Print",
      action: () => setInPdf(!inPdf),
      icon: inPdf ? <ArrowBackIcon /> : <PrintIcon />,
      disabled: false,
    },
  ];

  return (
    <>
      <NavBar title="PMM Guardian" buttons={buttons} />
      <div className={styles.simulatorPage}>
        {inPdf ? (
          <PDFView
            document={() => (
              <PdfPmmGuardianFile
                data={pmmGuardianValues}
                results={pmmGuardianResults}
              />
            )}
          />
        ) : (
          <PmmGuardianForm />
        )}
      </div>
    </>
  );
};
